import React from 'react';

import styled from 'styled-components';
import { device } from '../utils/breakpoints';
import ButtonLink, { ButtonColor } from '../components/ButtonLink';
import RocketShip from '../images/RocketShip.svg';
import Security from '../images/Security.svg';
import MoneyBills from '../images/MoneyBills.svg';
import WorldWide from '../images/Worldwide.svg';
import BlueBackground from '../components/backgrounds/BlueBackground';
import MarginContainer from '../components/MarginContainer';
import { graphql, useStaticQuery } from 'gatsby';
import useCommonTitles from '../components/useCommonTitles';

import ModernHome from './home-modern'

function IndexPage() {
  return (
    <ModernHome />
  );
}

export default IndexPage;
